import React, { useState, useEffect } from "react";
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import { Trash2, FileText, Loader2, X, Music2 } from "lucide-react";
import { fileUrl } from "@/lib/api";

export function Lightbox({ pol, onClose, onDelete, onTranscribe }) {
  const [confirmDel, setConfirmDel] = useState(false);
  const [transcribing, setTranscribing] = useState(false);
  useEffect(() => { setConfirmDel(false); setTranscribing(false); }, [pol?.id]);

  const ctype = pol?.content_type || "";
  const isVideo = ctype.startsWith("video/");
  const isAudio = ctype.startsWith("audio/");

  const doTranscribe = async () => {
    setTranscribing(true);
    try { await onTranscribe(pol); } finally { setTranscribing(false); }
  };

  return (
    <Dialog open={!!pol} onOpenChange={(o) => !o && onClose()}>
      <DialogContent data-testid="lightbox" className="bg-transparent border-none shadow-none p-0 max-w-lg [&>button]:hidden">
        <DialogTitle className="sr-only">{pol?.caption || "Media"}</DialogTitle>
        {pol && (
          <div className="relative">
            <button
              data-testid="lightbox-close"
              onClick={onClose}
              aria-label="Close"
              className="absolute -top-3 -right-3 z-50 w-10 h-10 rounded-full bg-white text-[#2b2620] paper-shadow-lift flex items-center justify-center hover:bg-[#ff3b30] hover:text-white transition-colors"
            >
              <X className="w-5 h-5" />
            </button>
            <div className="bg-white p-4 pb-14 paper-shadow-lift rotate-[-1.5deg]">
              {isVideo ? (
                <video data-testid="lightbox-video" src={fileUrl(pol.storage_path)} className="w-full max-h-[70vh]" controls autoPlay playsInline />
              ) : isAudio ? (
                <div data-testid="lightbox-audio" className="flex flex-col items-center gap-4 py-8">
                  <span className="w-20 h-20 rounded-full bg-[#efeae2] flex items-center justify-center"><Music2 className="w-9 h-9 text-[#a0703c]" /></span>
                  <audio src={fileUrl(pol.storage_path)} className="w-full" controls autoPlay />
                </div>
              ) : (
                <img src={fileUrl(pol.storage_path)} alt={pol.caption || "photo"} className="w-full object-contain max-h-[70vh]" />
              )}
              <p className="font-hand text-2xl text-center text-[#3a2f22] mt-4">{pol.caption || "untitled"}</p>
            </div>
            <div className="mt-4 flex justify-center gap-2 flex-wrap">
              {confirmDel ? (
                <div className="flex items-center gap-2 bg-white/95 rounded-full px-3 py-1.5 paper-shadow">
                  <span className="text-xs font-note text-[#8c7a55]">Delete this {isVideo ? "video" : isAudio ? "audio" : "photo"}?</span>
                  <button data-testid="lightbox-delete-confirm" onClick={() => { onDelete(pol.id); onClose(); }} className="text-xs font-display font-bold text-white bg-[#ff3b30] hover:bg-[#e0271d] rounded-full px-3 py-1">Yes, delete</button>
                  <button data-testid="lightbox-delete-cancel" onClick={() => setConfirmDel(false)} className="text-xs font-display font-bold text-[#6b6155] px-1">Cancel</button>
                </div>
              ) : (
                <>
                  {isVideo && (
                    <button data-testid="lightbox-transcribe" onClick={doTranscribe} disabled={transcribing} className="flex items-center gap-1.5 bg-white/95 hover:bg-white text-[#2b2620] rounded-full px-4 py-1.5 text-sm font-display font-bold paper-shadow transition-colors disabled:opacity-60">
                      {transcribing ? <Loader2 className="w-4 h-4 animate-spin" /> : <FileText className="w-4 h-4" />} Transcribe
                    </button>
                  )}
                  <button data-testid="lightbox-delete" onClick={() => setConfirmDel(true)} className="flex items-center gap-1.5 bg-white/95 hover:bg-white text-[#a0703c] hover:text-[#ff3b30] rounded-full px-4 py-1.5 text-sm font-display font-bold paper-shadow transition-colors">
                    <Trash2 className="w-4 h-4" /> Delete
                  </button>
                </>
              )}
            </div>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
}
